import React from 'react';

export default function PersonIcon() {
  return (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <title>Artboard 1</title>
      <path
        fill="currentColor"
        d="M17.07,2.93A10,10,0,1,0,20,10,10,10,0,0,0,17.07,2.93ZM10,.93a9.06,9.06,0,0,1,8.14,13,4.94,4.94,0,0,0-1.86-1.09,3.12,3.12,0,1,0-3.56.17,5,5,0,0,0-1.29.86,5.71,5.71,0,0,0-3-2.5,3.55,3.55,0,1,0-3.81,0,5.65,5.65,0,0,0-2.87,2.27A8.92,8.92,0,0,1,.94,10,9.06,9.06,0,0,1,10,.93Zm2.18,9.48a2.2,2.2,0,1,1,2.2,2.2A2.21,2.21,0,0,1,12.18,10.41Zm-8.31-2a2.65,2.65,0,1,1,2.64,2.64A2.65,2.65,0,0,1,3.87,8.43ZM10,19.05h0c-.29,0-.58,0-.86,0L8.82,19l-.5-.07-.42-.1a2.37,2.37,0,0,1-.36-.09c-.17,0-.33-.1-.5-.15l-.24-.09c-.19-.08-.39-.15-.58-.24l0,0a9,9,0,0,1-3.93-3.57,4.79,4.79,0,0,1,9.07,2.16A16.08,16.08,0,0,1,11.2,19l-.36.05C10.57,19,10.3,19.05,10,19.05Zm3.07-.56-.07,0-.64.2-.21.06h0a16.86,16.86,0,0,0,.08-2,5.5,5.5,0,0,0-.37-2,4,4,0,0,1,2.91-1.25,4.06,4.06,0,0,1,2.92,1.26A9,9,0,0,1,13.1,18.49Z"
      />
    </svg>
  );
}
